export default __webpack_public_path__ + "static/media/Steel City-2.dee9576a.jpg";